"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by leyla.markosyan on 10/3/2017.
 */
var HelpItem = /** @class */ (function () {
    function HelpItem(messageKey, url, type, subject, data) {
        this.messageKey = messageKey;
        this.url = url;
        this.type = type;
        this.subject = subject;
        this.data = data;
    }
    return HelpItem;
}());
exports.HelpItem = HelpItem;
//# sourceMappingURL=help-item.js.map